export enum HorizontalLogoPositions {
	UP_LEFT = 'UP_LEFT',
	UP_RIGHT = 'UP_RIGHT',
	DOWN_RIGHT = 'DOWN_RIGHT',
	DOWN_LEFT = 'DOWN_LEFT',
}

export enum VerticalLogoPositions {
	UP = 'UP',
	DOWN = 'DOWN',
}
